// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2MhPs","left":"InfoRow_left__2amFL"};